import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Every custom icon the app makes available as <mat-icon svgIcon="...">, keyed by the name
 * templates reference. Kept here rather than inline in AppComponent so that a component test
 * can register the same set without standing the whole app up — see registerStubSvgIcons in
 * src/testing.
 */
export const APP_SVG_ICONS: Readonly<Record<string, string>> = {
    'lps-password': 'assets/img/shared-icons/password.svg',
    'lps-personal-info': 'assets/img/shared-icons/personal info.svg',
    'lps-disclosure': 'assets/img/shared-icons/disclosure.svg',
    'lps-education': 'assets/img/shared-icons/education.svg',
    'lps-empty-search': 'assets/img/shared-icons/empty search.svg',
    'lps-error': 'assets/img/shared-icons/error.svg',
    'lps-no-results': 'assets/img/shared-icons/no results.svg',
    'lps-notification': 'assets/img/shared-icons/notification.svg',
    'lps-sign-up': 'assets/img/shared-icons/sign up.svg',
    'lps-social-background': 'assets/img/shared-icons/social background.svg'
};

@Injectable({
    providedIn: 'root'
})
export class SvgService {
    constructor(
        private readonly _registry: MatIconRegistry,
        private readonly _sanitizer: DomSanitizer
    ) {}

    register(iconName: string, url: string) {
        this._registry.addSvgIcon(
            iconName,
            this._sanitizer.bypassSecurityTrustResourceUrl(url)
        );
    }

    /** Registers the app's whole icon set; called once during app startup. */
    registerAppIcons() {
        Object.entries(APP_SVG_ICONS).forEach(([iconName, url]) =>
            this.register(iconName, url)
        );
    }
}
